/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Not_Ready_TitleInputs */

const en_us2_wrapped_period_not_ready_title = /** @type {(inputs: Wrapped_Period_Not_Ready_TitleInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`No closed month with a workout yet`);
	return /** @type {LocalizedString} */ (`No closed year with a workout yet`)
	
};

const pt_br2_wrapped_period_not_ready_title = /** @type {(inputs: Wrapped_Period_Not_Ready_TitleInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Ainda não há um mês fechado com treino`);
	return /** @type {LocalizedString} */ (`Ainda não há um ano fechado com treino`)
	
};

const es_419_wrapped_period_not_ready_title = /** @type {(inputs: Wrapped_Period_Not_Ready_TitleInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Aún no hay un mes cerrado con entrenamiento`);
	return /** @type {LocalizedString} */ (`Aún no hay un año cerrado con entrenamiento`)
	
};

const pt_pt2_wrapped_period_not_ready_title = /** @type {(inputs: Wrapped_Period_Not_Ready_TitleInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Ainda não há um mês fechado com treino`);
	return /** @type {LocalizedString} */ (`Ainda não há um ano fechado com treino`)
	
};

const fr_fr2_wrapped_period_not_ready_title = /** @type {(inputs: Wrapped_Period_Not_Ready_TitleInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Pas encore de mois bouclé avec une séance`);
	return /** @type {LocalizedString} */ (`Pas encore d'année bouclée avec une séance`)
	
};

const de_de2_wrapped_period_not_ready_title = /** @type {(inputs: Wrapped_Period_Not_Ready_TitleInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Noch kein abgeschlossener Monat mit Training`);
	return /** @type {LocalizedString} */ (`Noch kein abgeschlossenes Jahr mit Training`)
	
};

const it_it2_wrapped_period_not_ready_title = /** @type {(inputs: Wrapped_Period_Not_Ready_TitleInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Ancora nessun mese chiuso con un allenamento`);
	return /** @type {LocalizedString} */ (`Ancora nessun anno chiuso con un allenamento`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "No closed month with a workout yet" |
* | * | "No closed year with a workout yet" |
*
* @param {Wrapped_Period_Not_Ready_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_not_ready_title = /** @type {((inputs: Wrapped_Period_Not_Ready_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Not_Ready_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_not_ready_title(inputs)
	if (locale === "es-419") return es_419_wrapped_period_not_ready_title(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_not_ready_title(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_not_ready_title(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_not_ready_title(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_not_ready_title(inputs)
	return en_us2_wrapped_period_not_ready_title(inputs)
});
export { wrapped_period_not_ready_title as "wrapped-period.not_ready_title" }